import React, { useState, useEffect } from "react";
import api from "../../services/api.js";

const AddCustomerTransaction = ({
  open,
  onClose,
  token,
  cust_id,
  presetInvoiceId,
  presetAmount,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const initialForm = {
    userid: cust_id,
    currency: "IDR",
    description: "",
    amountin: "",
    fees: 0,
    rate: 1,
    transid: "",
    invoiceid: "",
    refundid: null,
    paymethodid: "",
    datepaid: "",
  };

  const [form, setForm] = useState(initialForm);

  const resetForm = () => {
    setForm(initialForm);
  };

  useEffect(() => {
    if (presetInvoiceId) {
      setForm((prev) => ({
        ...prev,
        userid: cust_id,
        invoiceid: presetInvoiceId,
        description: `Payment for Invoice #${presetInvoiceId}`,
        amountin: presetAmount ?? "",
      }));
    }
  }, [presetInvoiceId, cust_id, presetAmount]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await api.post("/transaction", form, {
        headers: {
          Authorization: token,
        },
      });

      alert("Transaksi berhasil ditambahkan");

      resetForm();
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error("Add transaction failed:", err);
      alert(err.response?.data?.message || "Gagal menambahkan transaksi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-lg p-6">
        <h3 className="text-lg font-semibold mb-4">Tambah Transaksi</h3>

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            name="description"
            value={form.description}
            readOnly
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
            required
          />

          <input
            name="amountin"
            type="number"
            placeholder="Amount In"
            value={form.amountin}
            onChange={handleChange}
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
            required
          />

          <input
            readOnly
            name="fees"
            type="number"
            value={form.fees}
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
          />

          <select
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
            name="paymethodid"
            value={form.paymethodid}
            onChange={handleChange}
            required
          >
            <option value="">Pilih Metode Pembayaran</option>

            <optgroup label="Skinet">
              <option value="SKI1">Mandiri</option>
              <option value="SKI2">BCA</option>
            </optgroup>

            <optgroup label="Duitku">
              <option value="VC">duitku Visa / Master Card / JCB</option>
              <option value="BC">duitku BCA Virtual Account</option>
              <option value="M2">duitku Mandiri Virtual Account</option>
              <option value="VA">duitku Maybank Virtual Account</option>
              <option value="I1">duitku BNI Virtual Account</option>
              <option value="B1">duitku CIMB Niaga Virtual Account</option>
              <option value="BT">duitku Permata Bank Virtual Account</option>
              <option value="A1">duitku ATM Bersama</option>
              <option value="AG">duitku Bank Artha Graha</option>
              <option value="NC">duitku Bank Neo Commerce/BNC</option>
              <option value="BR">duitku BRIVA</option>
              <option value="S1">duitku Bank Sahabat Sampoerna</option>
              <option value="DM">duitku Danamon Virtual Account</option>
              <option value="BV">duitku BSI Virtual Account</option>
              <option value="FT">duitku Pegadaian/ALFA/Pos</option>
              <option value="IR">duitku Indomaret</option>
              <option value="OV">duitku OVO</option>
              <option value="SA">duitku Shopee Pay Apps</option>
              <option value="LF">duitku LinkAja Apps (Fixed Fee)</option>
              <option value="LA">duitku LinkAja Apps (Percentage Fee)</option>
              <option value="DA">duitku DANA</option>
              <option value="SL">duitku Shopee Pay Account Link</option>
              <option value="OL">duitku OVO Account Link</option>
              <option value="JP">duitku Jenius Pay</option>
              <option value="SP">duitku Shopee Pay (QRIS)</option>
              <option value="NQ">duitku Nobu (QRIS)</option>
              <option value="DQ">duitku Dana (QRIS)</option>
              <option value="GQ">duitku Gudang Voucher (QRIS)</option>
              <option value="SQ">duitku Nusapay (QRIS)</option>
              <option value="DN">duitku Indodana Paylater</option>
              <option value="AT">duitku ATOME</option>
            </optgroup>
          </select>

          <input
            name="invoiceid"
            value={form.invoiceid}
            readOnly
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
          />

          <input
            name="transid"
            placeholder="Transaction ID"
            value={form.transid}
            onChange={handleChange}
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
          />

          <input
            name="datepaid"
            type="datetime-local"
            value={form.datepaid}
            onChange={handleChange}
            className="w-full rounded border px-3 py-2 dark:bg-gray-800 dark:border-gray-700"
          />

          <div className="flex justify-end gap-2 pt-3">
            <button
              type="button"
              onClick={() => {
                resetForm();
                onClose();
              }}
              className="px-4 py-2 rounded bg-gray-300"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 rounded bg-green-600 text-white"
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomerTransaction;
